// extracted by mini-css-extract-plugin
export default {"rowBtn":"UserActivity_rowBtn__uZXzs","inactive":"UserActivity_inactive__YJ4O3"};